import {
  SET_LEVEL,
  SET_TIPO,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
} from './mutations.type';

export default {
  [SET_TIPO](state, tipo) {
    state.tipo = tipo;
  },
  [SET_LEVEL](state, level) {
    state.level = level;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
};
